import { Directive, inject, type OnInit, output } from '@angular/core';

import { ChipComponent } from './chip.component';

@Directive({
  selector: 'ml-chip[mlDismissable]',
  host: {
    '(click)': 'this.dismissed.emit($event)',
  },
})
export class DismissableDirective implements OnInit {
  protected readonly dismissed = output<void>();

  private readonly host = inject(ChipComponent);

  ngOnInit(): void {
    this.host.isDismissable.set(true);
    this.host.trailingIcon.set('close');
    this.host.trailingIconSize.set('xs');
  }
}
